import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginLayout from '@/layouts/LoginLayout'
import SettingLayout from '@/layouts/SettingLayout'
import UCLayout from '@/layouts/UCLayout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/inner/login',
    name: 'Login',
    meta: {
      title: '登录-ADJUST RD'
    },
    component: () => import('@/views/login/Login')
  },
  {
    path: '/inner/wx-login',
    name: 'WxLogin',
    meta: {
      title: '微信登录-ADJUST RD'
    },
    component: () => import('@/views/login/WxLogin')
  },
  {
    path: '/loginLayout',
    name: 'LoginLayout',
    component: LoginLayout,
    children: [
      {
        path: '/login',
        name: 'Login',
        meta: {
          title: '登录-ADJUST RD'
        },
        component: () => import('@/views/login/Login')
      },
      {
        path: '/wx-login',
        name: 'WxLogin',
        meta: {
          title: '微信登录-ADJUST RD'
        },
        component: () => import('@/views/login/WxLogin')
      }
    ]
  },
  {
    path: '/settingLayout',
    name: 'SettingLayout',
    component: SettingLayout,
    children: [
      {
        path: '/usr/bind/wechat',
        name: 'BindWechat',
        meta: {
          title: '绑定微信-ADJUST RD'
        },
        component: () => import('@/views/bind/Wechat')
      },
      {
        path: '/usr/bind/mobile',
        name: 'BindMobile',
        meta: {
          title: '绑定手机号-ADJUST RD'
        },
        component: () => import('@/views/bind/Mobile')
      },
      {
        path: '/usr/settings',
        name: 'UserSettings',
        meta: {
          title: '用户设置-ADJUST RD'
        },
        component: () => import('@/views/login/UserSettings')
      },
      {
        path: '/pwd/reset',
        name: 'ResetPwd',
        meta: {
          title: '设置密码-ADJUST RD'
        },
        component: () => import('@/views/pwd/Reset')
      },
      {
        path: '/pwd/reset/success',
        name: 'ResetSuccess',
        meta: {
          title: '密码设置成功-ADJUST RD'
        },
        component: () => import('@/views/pwd/ResetSuccess')
      },
      {
        path: '/pwd/find-by-mobile',
        name: 'FindByMobile',
        meta: {
          title: '找回密码-ADJUST RD'
        },
        component: () => import('@/views/pwd/FindByMobile')
      },
      {
        path: '/pwd/find-by-wechat',
        name: 'FindByWechat',
        meta: {
          title: '找回密码-ADJUST RD'
        },
        component: () => import('@/views/pwd/FindByWechat')
      }
    ]
  },
  {
    path: '/usr',
    name: 'usr',
    component: UCLayout,
    children: [
      {
        path: '/usr/information',
        name: 'UserInformation',
        meta: {
          title: '用户中心-ADJUST RD'
        },
        component: () => import('@/views/usr/information')
      }
    ]
  },
  {
    path: '/usr/bind/success',
    name: 'BindSuccess',
    meta: {
      title: '绑定成功-ADJUST RD'
    },
    component: () => import('@/views/bind/Success')
  },
  {
    path: '/wxlogin/handler',
    name: 'WxLoginHandler',
    meta: {
      title: '登录中...-ADJUST RD'
    },
    component: () => import('@/views/login/WxLoginHandler')
  },
  {
    path: '/usr/bind/wechat/handler',
    name: 'BindWechatHandler',
    meta: {
      title: '绑定中...-ADJUST RD'
    },
    component: () => import('@/views/bind/BindWechatHandler')
  },
  {
    path: '/pwd/wechat/handler',
    name: 'FindByWechatHandler',
    meta: {
      title: '找回密码-ADJUST RD'
    },
    component: () => import('@/views/pwd/FindByWechatHandler')
  },
  {
    path: '/usr/bind/select-account',
    name: 'SelectAccount',
    meta: {
      title: '选择账号-ADJUST RD'
    },
    component: () => import('@/views/bind/SelectAccount')
  },
  {
    path: '/404',
    name: 'Error404',
    meta: {
      title: '404-ADJUST RD'
    },
    component: () => import('@/views/Error404')
  },
  {
    path: '/500',
    name: 'Error500',
    meta: {
      title: '500-ADJUST RD'
    },
    component: () => import('@/views/Error500')
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
